/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect, useCallback } from 'react';
import { Select } from 'antd';
import './InputProductos.css';
import { Item, LabelError } from './Item';
import { Tooltip } from "react-tippy";


const List = ({ data, onChangeCount }) => {
    const memoValue = React.useMemo(() => data, [data.length])
    return <div
        className='list-prd'>
        {memoValue.map(el => {
            return <Item
                count={el.count}
                nombre={el.nombre}
                descripcion={el.descripcion}
                precio={el.precio}
                index={el.index}
                key={"list-item-" + el.index}
                onChangeCount={(onChangeCount)}
            />
        })}
    </div>
}



const InputProductos = ({ inputs, updateProductos, error = false, label = "productos", help = "help", obligatory = true }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const newData = (inputs || []).map((el, index) => { return { ...el, index: index, count: 0 } });
        setData(newData);
    }, [inputs]);

    useEffect(() => {
        const total = data.map(el => el.precio * el.count).reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
        );
        updateProductos(data.filter(el => el.count >= 1), total);
    }, [data]);
    const onChangeCount = useCallback((index, value) => {
        setData(prevItems => prevItems.map((item, indexItem) => {
            if (index == indexItem) {
                item.count = value;
            }
            return item;
        }))
    }, []);

    const maxTextDisplay = (text, length) => {
        return text.substring(0, Math.min(length, text.length));
    }

    const displayText = (array) => {
        let text = array.map(function (data) {
            return data.nombre;
        }).join(", ");
        if (text.length > 40) {
            text = maxTextDisplay(text, 40);
            text += "..."
        }
        return text;
    }
    return (
        <div>
            {(label) &&
                <div>
                    <Tooltip
                        title={help}
                        trigger={"mouseenter"}
                        position={"top"}
                    >
                        <label>
                            {label ? label : ""} {obligatory && <span>*</span>}
                            <i className={`fa fa-info-circle prd-tooltip`} />
                        </label>
                    </Tooltip>
                </div>
            }
            {error &&
                <div>
                    <LabelError error={error}/>
                </div>}
            <Select
                placeholder="Seleccione"
                className='select-prd'
                size='large'
                listHeight={100}
                value={1}
                mode="multiple"
                showSearch={false}
                tagRender={() => {
                    const datos = data.filter(el => el.count >= 1);
                    return <div className='d-flex'>
                        {displayText(datos)}
                    </div>
                }}
                dropdownRender={() => <List data={data} key="list-prd" onChangeCount={onChangeCount} />} />
        </div>
    );
}

export default InputProductos;